import type { CageFishGroupHistoryItem, FishGroupLocationHistoryItem } from '../historyTypes';
import type { CageFishGroupHistoryItemDto, FishGroupLocationHistoryItemDto } from '../types';

import { asFishGroupStatus } from './enumGuards';

// ---------------------------------------------------------------------------
// Location history
// ---------------------------------------------------------------------------

export function mapFishGroupLocationsToDomain(
    dtos: FishGroupLocationHistoryItemDto[]
): FishGroupLocationHistoryItem[] {
    return dtos.map(mapFishGroupLocationToDomain);
}

function mapFishGroupLocationToDomain(
    dto: FishGroupLocationHistoryItemDto
): FishGroupLocationHistoryItem {
    return {
        id: dto.id,
        cageId: dto.cageId,
        cageName: dto.cageName,
        locationId: dto.locationId,
        locationName: dto.locationName,
        fromDate: dto.fromDate,
        toDate: dto.toDate ?? null,
        reason: dto.reason ?? null,
    };
}

// ---------------------------------------------------------------------------
// Cage timeline
// ---------------------------------------------------------------------------

export function mapCageFishGroupHistoryToDomain(
    dtos: CageFishGroupHistoryItemDto[]
): CageFishGroupHistoryItem[] {
    return dtos.map((dto) => ({
        fishGroupId: dto.fishGroupId,
        fishGroupName: dto.fishGroupName,
        status: asFishGroupStatus(dto.status),
        fromDate: dto.fromDate,
        toDate: dto.toDate ?? null,
        reason: dto.reason ?? null,
    }));
}
